import React, { useEffect } from 'react';
import Button from '@mui/material/Button';
import { useDispatch } from 'react-redux';
import * as actions from '../../../reducers/form';
import * as api from '../../../api/list'
import validateProps from '../../../functions/validateProps'
import { enqueueSnackbar } from '../../../reducers/notifier'
import SimpleAdd from '../../../components/SimpleAdd'
import { typeMachine } from '../../../enum/type-machine.enum'

const arrProps = [
  { bp: { md: 6, sm: 12 }, field: 'typeM', type: 'autoArr', label: 'Тип техники', textProps: { arr: typeMachine }, validator: [(value) => !!value], errorText: 'Поле обязательно' },
  { bp: { md: 6, sm: 12 }, field: 'model', type: 'text', label: 'Модель' },
  { bp: { md: 6, sm: 12 }, field: 'govNumber', type: 'text', label: 'Гос. номер' },
  { bp: { md: 6, sm: 12 }, field: 'fuelConsumption', type: 'text', label: 'Норма потребления топлива', textProps: { type: 'number' } },
]
const formName = 'MachineAdd'
export default function MachineAdd({ history }) {
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(actions.formInitialize({ name: '', errorValidate: { name: false } }, { name: formName }))
    return () => {
      dispatch(actions.formDestroy({ name: formName }))
    }
  }, [dispatch])
  const handleSave = (e) => {
    dispatch((disp, getState) => {
      const state = getState()
      const values = state.form[formName]?.values
      const isError = validateProps(arrProps, values)
      disp(actions.formChange(isError.validate, { field: 'errorValidate', name: formName }))
      if (isError.check) {
        disp(enqueueSnackbar({
          message: `некорректные поля`,
          options: { variant: 'error' }
        }))
        return;
      }
      disp(actions.formSubmitAPI({
        props: {
          typeM: values.typeM,
          model: values.model,
          govNumber: values.govNumber,
          fuelConsumption: values.fuelConsumption
        },
        url: api.addMachine.path,
        method: api.addMachine.type,
        history: history
      }, formName))
    })
  };
  return (
    <div className='App-paper'>
      <form autoComplete="off" onSubmit={handleSave}>
        <div style={{ padding: '16px' }}>
          <SimpleAdd
            arr={arrProps}
            formName={formName}
            title='Добавить технику'
            gridProps={{ xs: 12, xl: 9, lg: 10 }}
          />
        </div>
        <Button color="primary" onClick={() => history.goBack()}>Назад </Button>
        <Button type="submit" color="primary">Сохранить</Button>
      </form>
    </div>
  );
}
